<template>
  <vs-sidebar
    position-right
    parent=".course-form"
    default-index="1"
    color="primary"
    class="sidebarx"
    spacer
    v-model="handleActive"
  >
    <div class="px-5 rating-detail" v-if="active">
      <div class="flex">
        <div class="w-1/3 mr-5 ml-auto">
          <label>From:</label>
          <datepicker v-model="ratingReportsFrom"></datepicker>
        </div>
        <div class="w-1/3 mr-5 ml-auto">
          <label>To:</label>
          <datepicker v-model="ratingReportsTo"></datepicker>
        </div>
        <vs-button
          @click="generateCourseReport"
          class="ml-auto mx-2 mt-5"
          type="border"
          icon-pack="feather"
          >Generate Course Report</vs-button
        >
      </div>
      <div class="mt-5 mb-10 w-full clear-both text-right"><small>You'll generate a report, then you can download it in the <a href="/reports">Report center</a></small></div>
      <div
        class="flex flex-wrap px-5 mt-10 mb-10 border-0 border-b border-solid border-grey-light"
        v-for="rating in contentRatings"
        :key="rating.id"
      >
        <div class="rating-detail__course w-1/3">
          <strong>Course rating</strong>
          <rating-stars :rating="rating.rating" />
        </div>
        <div class="rating-detail__instructor w-1/3">
          <strong>Instructor rating</strong>
          <rating-stars :rating="rating.instructor_rating" />
        </div>
        <div class="rating-detail__created w-1/3">
          <strong>Created</strong>
          <div>{{ rating.created | dateFormat }}</div>
        </div>
        <div class="rating-detail__comment w-full mt-10 pb-5">
          {{ rating.observations }}
        </div>
      </div>
      <vs-pagination
        v-model="currentPage"
        :total="totalPages"
        :max-items="pageSize"
        :size-array="contentRatings.length"
      >
      </vs-pagination>
    </div>
  </vs-sidebar>
</template>

<script>
import { mapActions } from 'vuex'
import Datepicker from 'vuejs-datepicker'
import dayjs from 'dayjs'
import RatingStars from '@/components/RatingStars.vue'

export default {
  name: 'RatingDetails',
  components: {
    RatingStars,
    Datepicker,
  },
  props: {
    courseId: String,
    active: Boolean,
  },
  data() {
    return {
      contentRatings: [],
      currentPage: 1,
      totalPages: 1,
      pageSize: 30,
      totalItems: 0,
      starsConfig: {
        rating: 0,
        isIndicatorActive: false,
        style: {
          fullStarColor: '#ed8a19',
          emptyStarColor: '#737373',
          starWidth: 10,
          starHeight: 10,
        },
      },
      ratingReportsFrom: dayjs().subtract(6, 'month').toDate(),
      ratingReportsTo: new Date(),
    }
  },
  computed: {
    handleActive: {
      get() {
        return this.active
      },
      set(value) {
        this.$emit('change-sidebar', value)
      },
    },
  },
  methods: {
    ...mapActions('ratings', ['searchRatings', 'getRatingsCSV']),
    ...mapActions('reporting', ['createRatingReportAction']),
    async generateCourseReport() {
      try {
        await this.createRatingReportAction({
          type: 'rating',
          model_id: this.courseId,
          model_type: 'course',
          from: dayjs(this.ratingReportsFrom).format('YYYY-MM-DD'),
          to: dayjs(this.ratingReportsTo).add(1, 'day').format('YYYY-MM-DD'), // to 00:00:00 of next day.
        })
        this.$vs.notify({
          title: 'Success',
          text: 'Go to the Report center to download the report',
          color: 'information',
          position: 'top-right',
        })
      } catch (error) {
        this.showError(error)
      }
      
    },
    async search(payload = {}) {
      try {
        const response = await this.searchRatings(payload)
        return response
      } catch (error) {
        this.showError(error)
      }
    },
    async handleChangePage(page) {
      this.currentPage = page
      this.coursesRatings({
        page: this.currentPage.toString(),
      })
    },
    async coursesRatings(payload) {
      payload = {
        ...payload,
        model_id: this.courseId,
        page_size: this.pageSize.toString(),
        ordering: '-created',
      }
      const response = await this.search(payload)
      this.totalItems = response ? response.count : 0
      this.contentRatings = response ? response.results : []
    },
  },
  watch: {
    courseId: async function (newValue) {
      if (!newValue) return
      this.loading = true
      await this.coursesRatings()
      setTimeout(() => (this.loading = false), 500)
    },
    currentPage: async function (newValue) {
      if (!newValue) return
      this.loading = true
      this.handleChangePage(newValue)
      setTimeout(() => (this.loading = false), 500)
    },
  },
  async mounted() {
    if (this.courseId) {
      await this.coursesRatings()
    }
  },
}
</script>
